export function toInteger(value: any, defaultValue: number): number {
  let result = parseInt(value, 10);
  return isNaN(result) ? defaultValue : result;
}

export function toNullableInteger(value: any): number | null {
  if (value === null || value === undefined || value.toString().trim() === '')
      return null;

  let result = parseInt(value, 10);
  return isNaN(result) ? null : result;
}

export function toFloat(value: any, defaultValue: number): number {
  if (value === null || value === undefined || value.toString().trim() === '')
      return defaultValue;

  let result = parseFloat(value.toString().replace(',', '.'));
  return isNaN(result) ? defaultValue : result;
}

export function toNullableText(value: any): string | null {
  if (value === null || value === undefined)
      return null;

  let result = value.toString().trim();
  return result === '' ? null : result;
}
